
import { reactive} from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "WildBookObserveSpecCoordinates",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "api/Form/loadForm",
      apiSaveMethod: "",
      form: "WildbuchEintragBeobachtungSpez",
      page: "WildbuchEintragLokalisierungBeobachtungSpezial",
      remoteId: "",
      waitForResponse: true,
      geoEditMode: "New",
      geoGpsMode: "OnStartup",
      geoDisplayClass: "additional",
      geoCheckInsidePolygon: true        
    });
    return {
      request
    };
  }
};
